import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private readonly languageKey = 'selectedLanguage';

  setLanguage(language: string) {
    localStorage.setItem(this.languageKey, language);
  }

  getLanguage(): string {
    return localStorage.getItem(this.languageKey) || 'en';
  }
}